window['Theme_Product'] = ({
  product,
  variant,
  featuredMediaId,
  enableImageZoom = false,
  enableThumbnailsOnDesktop = false,
}) => {
  return {
    productForms: null,
    productRoot: null,
    product: product,
    currentVariant: variant,
    currentMediaId: featuredMediaId,
    loading: false,
    quantity: '1',
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    variantChanged: false,
    updateStoreAvailability: null,
    videoInView: false,
    hasGiftCardRecipientForm: false,
    cartAddErrorMessage: '',
    lastClickedThumbnail: null,
    currentOption1: variant.option1,
    currentOption2: variant.option2,
    currentOption3: variant.option3,
    enableThumbnailsOnDesktop,
    get options() {
      let arr = [];
      if (this.currentOption1) {
        arr.push(this.currentOption1);
      }
      if (this.currentOption2) {
        arr.push(this.currentOption2);
      }
      if (this.currentOption3) {
        arr.push(this.currentOption3);
      }
      return arr;
    },
    get currentVariantId() {
      if (this.currentVariant) {
        return this.currentVariant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];

      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.currentVariant) {
        return this.currentVariant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.currentVariant && this.currentVariant.title) {
        if (!this.currentVariant.title.includes('Default')) {
          return this.currentVariant.title;
        }
      }
      return '';
    },
    get current_price() {
      return this.currentVariant.price;
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide');

      return splideIsNotDestroyed(splideEl);
    },
    formatMoney(price, moneyFormat = theme.defaultMoneyFormat) {
      return formatMoney(price, moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      if (this.$root.querySelector('[x-data="Theme_GiftCardRecipient"]')) {
        this.hasGiftCardRecipientForm = true;
      }

      this.updateStoreAvailability = debounce(
        this.__updateStoreAvailability.bind(this),
        150
      );

      this.productForm = this.$root.querySelector(
        `[data-product-form-container]`
      );

      if (theme.settings.cart_type === 'drawer') {
        const formEl = this.productForm.querySelector('.product-form');
        if (formEl) {
          formEl.addEventListener('submit', this.submitForm.bind(this));
        }
      }

      this.getOptionHandles();

      this.$root.addEventListener('cascade:product:slidechange', (e) => {
        this.currentMediaId = parseInt(e.detail.currentMediaId, 10);
      });

      this.$watch('currentMediaId', (value, oldValue) => {
        let shouldFocusWrapper = false;

        if (this.lastClickedThumbnail === value) {
          shouldFocusWrapper = true;
        }

        this.lastClickedThumbnail = null;

        const currentMediaObject = this.product.media.filter((media) => {
          return media.id === value;
        })[0];

        this.videoInView =
          currentMediaObject.media_type === 'video' ||
          currentMediaObject.media_type === 'external_video'
            ? true
            : false;

        if (this.isUsingSlideshowToDisplayMedia) {
          if (shouldFocusWrapper) {
            const newMediaWrapperEl = Array.from(
              this.$root.querySelectorAll(
                `[data-product-single-media-wrapper="${value}"]`
              )
            ).filter((mediaWrapperEl) =>
              Boolean(mediaWrapperEl.offsetParent)
            )[0];

            if (newMediaWrapperEl) {
              this.$focus.focus(newMediaWrapperEl);
            }
          }
        }

        if (this.enableThumbnailsOnDesktop) {
          this.$root.dispatchEvent(
            new CustomEvent('cascade:product:mediachange', {
              bubbles: true,
              detail: {
                media_id: this.currentMediaId,
                slideshow_id: this.$root.querySelector('.splide--product')?.id,
              },
            })
          );
        }

        // There can be more than one media (e.g. for different breakpoints)
        // so we check the offsetHeight to see if the wrapper could currently
        // be visible

        // https://davidwalsh.name/offsetheight-visibility

        this.$root
          .querySelectorAll(`[data-product-single-media-wrapper="${oldValue}"]`)
          .forEach((mediaWrapperEl) => {
            if (Boolean(mediaWrapperEl.offsetHeight)) {
              mediaWrapperEl.dispatchEvent(new CustomEvent('mediaHidden'));
            }
          });

        this.$root
          .querySelectorAll(`[data-product-single-media-wrapper="${value}"]`)
          .forEach((mediaWrapperEl) => {
            if (Boolean(mediaWrapperEl.offsetHeight)) {
              mediaWrapperEl.dispatchEvent(new CustomEvent('mediaVisible'));
            }
          });
      });

      this.updateStoreAvailability(this.currentVariant);

      const inventoryData = this.productRoot.querySelector('#inventory_data');
      if (inventoryData) {
        this.inventoryDataObject = JSON.parse(inventoryData.innerHTML);
      } else {
        this.inventoryDataObject = {};
      }

      const variantsMetaData = this.productRoot.querySelector('#variants_meta_data');
      if (variantsMetaData) {
        this.variantsMetaDataObject = JSON.parse(variantsMetaData.innerHTML);
      } else {
        this.variantsMetaDataObject = {};
      }

      this.updateShippingMessage();

      this.$root.addEventListener('cascade:product:variantchange', this.updateShippingMessage.bind(this));
      this.$root.addEventListener('cascade:product:variantchange', this.updateSample.bind(this));
      this.$root.addEventListener('sample-add-to-cart', this.sampleAddToCart.bind(this));
      this.$root.addEventListener('contact-customer-service', this.contactCustomerService.bind(this));
    },
    updateShippingMessage(event) {
      console.log('updateShippingMessage');

      const selectors = {
        shippingMessage: ".ship-message",
        readyToShipMessageText: '.ready-to-ship-message-text',
        paymentButtonsContainer: '.product-block-buy-buttons',
        preorderMessage: '.preorder-message',
        quantityMessage: '.quantity-message',
        addToCartText: '.add-to-cart-btn',
        buyNowButton: '.shopify-payment-button'
      }

      const shippingMessageContainer = this.$root.querySelector(selectors.shippingMessage);
      const paymentButtonsContainer = this.$root.querySelector(selectors.paymentButtonsContainer);
      const preorderMessage = this.$root.querySelector(selectors.preorderMessage);
      const quantityMessage = this.$root.querySelector(selectors.quantityMessage);
      const cartBtnText = this.$root.querySelector(selectors.addToCartText);
      const buyNowButton = this.$root.querySelector(selectors.buyNowButton);

      const quantityInputElement = this.$root.querySelector('input[name="quantity"]');

      const variants_inventory_data = this.inventoryDataObject['variants'];
      const inventoryData = variants_inventory_data[this.currentVariantId];

      clearShippingMessageContainers();
      let shippingMessage = "";
      if (inventoryData.status && inventoryData.status !== "---") {
        console.log("we have inventory data");
        shippingMessage = getShippingMessageFromInventoryData.call(this, this.currentVariant, inventoryData);
      } else {
        console.log("we don't have inventory data");
        shippingMessage = getShippingMessage.call(this, this.currentVariant, inventoryData);
      }

      shippingMessageContainer.innerHTML = shippingMessage;

      function getShippingMessageFromInventoryData(variant, inventoryData) {
        const InventoryStatus = {
          AVAILABLE: 'available',                     // Item is available and in stock
          OUT_OF_STOCK: 'out_of_stock',            // Item is completely out of stock
          OUT_OF_STOCK_PURCHASABLE: 'out_of_stock_purchasable', // Item is out of stock but can still be purchased
          DISCONTINUED: 'discontinued',             // Item has been discontinued
          PREORDER: 'preorder',                    // Item is available for preorder
          ETA: 'eta',                              // Item is out of stock but has an ETA
        };

        // Make the enum immutable
        Object.freeze(InventoryStatus);

        if (!variant) {
          return null;
        }

        const variant_sku = variant.sku;
        const vendor = this.product.vendor;
        const tags = this.product.tags;
        const variant_inventory = inventoryData.inventory_quantity ? parseInt(inventoryData.inventory_quantity, 10) : null;
        const variant_id = variant.id;
        const isNoQShip = tags.includes(`${variant_sku}_NOQSHIP`);
        const has_advanced_quickship = vendor == "Meri Meri" || tags.includes('castelli');

        updateQuantityInputMaxValue.call(this);

        let shippingText = "";

        shippingText = getStopShippingTag(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'getStopShippingTag');
          return shippingText;
        }

        shippingText = getPreorderShippingTag(tags, variant_sku, variant_inventory);
        if (shippingText) {
          console.log(variant_sku, 'getPreorderShippingTag');
          // message is display in the preorderMessage container
          return shippingText;
        }

        shippingText = getProductSos(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'getProductSos');
          return shippingText;
        }

        shippingText = handleIsNoQShip(tags, variant_sku, variant_id, variant_inventory, isNoQShip, has_advanced_quickship);
        if (shippingText) {
          console.log(variant_sku, 'handleIsNoQShip');
          return shippingText;
        }

        shippingText = handleSpecialOrder(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSpecialOrder');
          return shippingText;
        }

        shippingText = handleFermSpecialOrder(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleFermSpecialOrder');
          return shippingText;
        }

        shippingText = handlePositiveInventory(tags, variant_sku, variant_inventory, isNoQShip);
        if (shippingText) {
          console.log(variant_sku, 'handlePositiveInventory');
          return shippingText;
        }

        shippingText = handleSkuExtendedLeadtime(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSkuExtendedLeadtime');
          return shippingText;
        }

        shippingText = handleStatusCheckVerified(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleStatusCheckVerified');
          return shippingText;
        }

        shippingText = handlePlpopenbox(tags);
        if (shippingText) {
          console.log(variant_sku, 'handlePlpopenbox');
          return shippingText;
        }

        if (inventoryData.status === InventoryStatus.AVAILABLE) {
          console.log("testing available");
          shippingText = filterShippingTag(this.inventoryDataObject.shipping_tag);
          console.log("shippingText", shippingText);
          return shippingText;
        }

        if (inventoryData.status === InventoryStatus.ETA) {
          console.log("testing eta");
          shippingText = getETAShippingMessage(inventoryData);
          console.log("shippingText", shippingText);
          return shippingText;
        }

        if (inventoryData.status === InventoryStatus.OUT_OF_STOCK_PURCHASABLE) {
          console.log("testing out of stock purchasable");
          shippingText = 'For Shipping Information Please Contact Support.';
          console.log("shippingText", shippingText);
          return shippingText;
        }

        if (inventoryData.status === InventoryStatus.OUT_OF_STOCK) {
          console.log("testing out of stock");
          shippingText = 'For Shipping Information Please Contact Support.';
          console.log("shippingText", shippingText);
          showBackInStockButton(); // we don't have this implemented yet
          hidePaymentButtons();
          return shippingText;
        }

        if (inventoryData.status === InventoryStatus.DISCONTINUED) {
          if (inventoryData.available_quantity > 0 ) {
            shippingText = filterShippingTag(this.inventoryDataObject.shipping_tag);
            updateQuantityInputMaxValue.call(this, inventoryData.available_quantity);
            console.log("shippingText", shippingText);
            return shippingText;
          }
  
          console.log("testing discontinued with no inventory");
          showBackInStockButton(); // we don't have this implemented yet
          hidePaymentButtons();
          hideShippingMessageContainer();
        }
      }

      function updateQuantityInputMaxValue(maxValue=null) {
        // console.log("quantityInputElement", quantityInputElement);
        if (!quantityInputElement) {
          console.log("quantityInputElement not found");
          return;
        }

        if (maxValue) {
          quantityInputElement.setAttribute('max', maxValue);
          quantityInputElement.value = Math.min(quantityInputElement.value, maxValue);
          this.maxValue = maxValue;
        } else {
          quantityInputElement.removeAttribute('max');
          this.maxValue = null;
        }
      }

      function getShippingMessage(variant, inventoryData) {
        console.log("getShippingMessage");
        if (!variant) {
          return null;
        }

        const variant_sku = variant.sku;
        const vendor = this.product.vendor;
        const tags = this.product.tags;
        const variant_inventory = inventoryData.inventory_quantity ? parseInt(inventoryData.inventory_quantity, 10) : null;
        const variant_id = variant.id;
        const isNoQShip = tags.includes(`${variant_sku}_NOQSHIP`);
        const has_advanced_quickship = vendor == "Meri Meri" || tags.includes('castelli');


        let shippingText = ""

        shippingText = getStopShippingTag(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'getStopShippingTag');
          return shippingText;
        }

        shippingText = getPreorderShippingTag(tags, variant_sku, variant_inventory);
        if (shippingText) {
          console.log(variant_sku, 'getPreorderShippingTag');
          // message is display in the preorderMessage container
          return shippingText;
        }

        shippingText = getProductSos(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'getProductSos');
          return shippingText;
        }

        shippingText = handleIsNoQShip(tags, variant_sku, variant_id, variant_inventory, isNoQShip, has_advanced_quickship);
        if (shippingText) {
          console.log(variant_sku, 'handleIsNoQShip');
          return shippingText;
        }

        shippingText = handleSpecialOrder(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSpecialOrder');
          return shippingText;
        }

        shippingText = handleFermSpecialOrder(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleFermSpecialOrder');
          return shippingText;
        }

        shippingText = handlePositiveInventory(tags, variant_sku, variant_inventory, isNoQShip);
        if (shippingText) {
          console.log(variant_sku, 'handlePositiveInventory');
          return shippingText;
        }

        shippingText = handleNegativeInventory(tags, variant_sku, variant_inventory, vendor);
        if (shippingText) {
          console.log(variant_sku, 'handleNegativeInventory');
          return shippingText;
        }

        shippingText = handleConfirmedMwDisco(tags, variant_sku, variant_id, variant_inventory);
        if (shippingText) {
          console.log(variant_sku, 'handleConfirmedMwDisco');
          return shippingText;
        }

        shippingText = handleSkuExtendedLeadtime(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSkuExtendedLeadtime');
          return shippingText;
        }

        shippingText = handleSkuConfirmedMwDiscoOos(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSkuConfirmedMwDiscoOos');
          return shippingText;
        }

        shippingText = handleStatusCheckVerified(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleStatusCheckVerified');
          return shippingText;
        }

        shippingText = handleAssumedMwDisco(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleAssumedMwDisco');
          return shippingText;
        }

        shippingText = handleNoname(tags, variant_sku, variant_inventory, vendor);
        if (shippingText) {
          console.log(variant_sku, 'handleNoname');
          return shippingText;
        }

        shippingText = handlePlpopenbox(tags);
        if (shippingText) {
          console.log(variant_sku, 'handlePlpopenbox');
          return shippingText;
        }

        shippingText = handleReadyToShip(tags, variant_sku, variant_inventory);
        if (shippingText) {
          console.log(variant_sku, 'handleReadyToShip');
          return shippingText;
        }

        shippingText = handleSkuDateShip(tags, variant_sku);
        if (shippingText) {
          console.log(variant_sku, 'handleSkuDateShip');
          return shippingText;
        }

        shippingText = handleShipping(tags, variant_sku, variant_inventory);
        if (shippingText) {
          console.log(variant_sku, 'handleShipping');
          return shippingText;
        }

        console.log("NOT FOUND", variant_sku);

        return shippingText;
      }

      function clearShippingMessageContainers() {
        shippingMessageContainer.innerHTML = "";
        shippingMessageContainer.classList.remove('hide');
        paymentButtonsContainer.classList.remove('hide');
      }

      function hidePaymentButtons() {
        paymentButtonsContainer.classList.add('hide');
      }

      function hideShippingMessageContainer() { 
        shippingMessageContainer.classList.add('hide');
      }

      function showQuickshipBadge() { 
        console.log("show quickship badge");
      }

      function showReadyToShipBadge() {
        console.log("show ready to ship badge");
      }

      function showNoEtaButtons() {
        console.log("show no eta buttons");
      }

      function showBackInStockButton() {
        console.log("show back in stock button");
      }

      function getStopShippingTag(tags, variant_sku) {
        let stopShippingTag = tags.find(tag => tag.includes(`${variant_sku}_STOPMW-SHIPPING`));
        if (stopShippingTag) {
          let weeks = stopShippingTag.replace(`${variant_sku}_STOPMW-SHIPPING`, "");
          if (weeks.endsWith('WK')) {
            weeks = weeks.replace('WK', '');
            return `Ships in ${weeks} weeks.`;
          }
        }
        return null;
      }

      function getPreorderShippingTag(tags, variant_sku, variant_inventory) {
        let availShipTagExists = tags.some(tag => tag.includes(`${variant_sku}_AVAIL_SHIP`));
        // if (!availShipTagExists && variant_inventory <= 0) {
          for (let tag of tags) {
            if (tag.includes(`${variant_sku}_PREORDER_`) && variant_sku) {
              let elements = tag.split('_');
              let date = elements[elements.length - 1].split('-');
              let fullDate = new Date(`${date[2]}-${date[0]}-${date[1]}`);
              let monthName = fullDate.toLocaleString('default', { month: 'long' });
              let monthState = '';
              if (1 <= parseInt(date[1]) && parseInt(date[1]) <= 10) {
                monthState = "Early";
              } else if (11 <= parseInt(date[1]) && parseInt(date[1]) <= 20) {
                monthState = "Mid";
              } else {
                monthState = "Late";
              }
  
              // preorderMessage.innerHTML = `Purchase now and we'll ship when it's available. Estimated in ${monthState} ${monthName} ${date[2]}.`;
              // preorderMessage.classList.remove('hide');

  
              cartBtnText.textContent = "PREORDER";
              // buyNowButton.classList.add('hide'); 
  
              return `Purchase now and we'll ship when it's available. Estimated in ${monthState} ${monthName} ${date[2]}.`;
            }
          }
        // }
        return null;
      }

      function getProductSos(tags, variant_sku) {
        if (tags.includes("PRODUCT_SOS") || tags.includes(`${variant_sku}_PRODUCT_SOS`)) {
          hidePaymentButtons();
          showBackInStockButton();  // we don't have this implemented yet
          hideShippingMessageContainer();
          return "Notify me when available";
        }
        return null;
      }

      function handleIsNoQShip(tags, variant_sku, variant_id, variant_inventory, isNoQShip, has_advanced_quickship) {
        console.log(isNoQShip, variant_inventory, has_advanced_quickship);
        if (!isNoQShip) {
          if (variant_inventory > 0) {
            if (!has_advanced_quickship) {
              showQuickshipBadge();
              return 'Shipping time: 1 to 2 business days to ship. Lead times may be extended based on availability, customer service will contact you with any updates.';
            } else {
              return null;
            }
          }
        }
      
        return null;
      }

      function handleSpecialOrder(tags, variant_sku) {
        let special_order_tag = tags.find(tag => /^SPECIALORDER-SHIP-\d/.test(tag));
        if (special_order_tag) {
          let weeks = special_order_tag.replace("SPECIALORDER-SHIP-", "");
          return `<strong><span>**Please note** this item is a SPECIAL ORDER and is FINAL SALE.<br>Special Order Delivery Information:<br>Please allow an additional ${weeks} weeks delivery time, depending on your location.<br>Special orders begin production immediately upon order placement and are built to your specifications. As a result, the item(s) cannot be canceled, changed, returned or refunded at any time.<br><br></span></strong>`;
        }
      
        return null;
      }

      function handleFermSpecialOrder(tags, variant_sku) {
        const specialOrderTags = ["FERM-SPECIALORDER", `${variant_sku}_FERM-SPECIALORDER`];
        const isSpecialOrder = specialOrderTags.some(tag => tags.includes(tag));
      
        if (isSpecialOrder) {
          return `<strong><span>**Please note** this item is a SPECIAL ORDER and is FINAL SALE.<br>Special Order Delivery Information:<br>Please allow an additional 22-26 weeks delivery time, depending on your location.<br>Special order merchandise is considered final sale.<br>Special orders begin production immediately upon order placement and are built to your specifications. As a result, the item(s) cannot be canceled, changed, returned or refunded at any time.<br><br></span></strong>`;
        }
      
        return null;
      }

      function handlePositiveInventory(tags, variant_sku, variant_inventory, isNoQShip) {
        if (variant_inventory > 0 && !isNoQShip) {
          showQuickshipBadge();
          return "Shipping time: 1 to 2 business days to ship. Lead times may be extended based on availability, customer service will contact you with any updates.";
        }
      
        return null;
      }

      function handleSkuExtendedLeadtime(tags, variant_sku) {
        if (tags.includes(`${variant_sku}_EXTENDED_LEADTIME`)) {
          showNoEtaButtons();
          hidePaymentButtons();
          hideShippingMessageContainer();
          return "activate no ATC Button";
        }
      
        return null;
      }

      function handleStatusCheckVerified(tags, variant_sku) {
        if (tags.includes(`${variant_sku}_STATUS-CHECK`) || tags.includes("STATUS-CHECK") || tags.includes(`${variant_sku}_STATUS-VERIFIED`)) {
          showNoEtaButtons();
          hidePaymentButtons();
          hideShippingMessageContainer();
          return "activate no ATC Button";
        }
      
        return null;
      }

      function handlePlpopenbox(tags) {
        if (tags.includes("plpopenbox")) {
          return `<strong>IN STOCK + READY TO SHIP</strong><br><br><strong>Shipping time: 1-2 weeks to ship.</strong>`;
        }
        return null;
      }

      function filterShippingTag(shippingTag) {
        let bigger_date = shippingTag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, '');
        if (shippingTag.endsWith("WH")) {
          return `<span>${bigger_date.replace('-', ' to ')} business days to leave the warehouse</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }

        if (["SHIPPING2-3VARIABLE", "SHIPPING3-4VARIABLE", "SHIPPING3-5VARIABLE"].includes(shippingTag)) {
          return `<span>${bigger_date.replace('-', ' to ')} weeks to ship.</span>`;
        }

        let txt_;
        if (/\dWK$/.test(shippingTag) || /\dWKVARIABLE$/.test(shippingTag) || /\dWKSVARIABLE$/.test(shippingTag)) {
          txt_ = `${bigger_date.replace('-', ' to ')} weeks to ship`;
        } else if ( /\d$/.test(shippingTag) || /\dVARIABLE$/.test(shippingTag)) {
          txt_ = `<span>${bigger_date.replace('-', ' to ')} business days to ship.</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }
      
        return txt_;
      }

      function filteredShippingTag(tags, variant_sku) {
        let shipping_tags = tags.filter(tag => /^SHIPPING\d/.test(tag));
        if (!shipping_tags.length) {
          return null;
        }
      
        let bigger_tag, bigger_date;
        if (shipping_tags.length) {
          let stripped_numbers = shipping_tags.map(tag => tag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, ''));
          let additions = stripped_numbers.map(tag => tag.split('-').reduce((a, b) => parseInt(a) + parseInt(b), 0));
          let bigger_number = Math.max(...additions);
          let index_of_bigger_number = additions.indexOf(bigger_number);
          bigger_tag = shipping_tags[index_of_bigger_number];
          bigger_date = stripped_numbers[index_of_bigger_number];
        } else {
          bigger_tag = shipping_tags[0];
          bigger_date = bigger_tag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, '');
        }
      
        if (bigger_tag.endsWith("WH")) {
          return `<span>${bigger_date.replace('-', ' to ')} business days to leave the warehouse</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }
      
        if (["SHIPPING2-3VARIABLE", "SHIPPING3-4VARIABLE", "SHIPPING3-5VARIABLE"].includes(bigger_tag)) {
          return `<span>${bigger_date.replace('-', ' to ')} weeks to ship.</span>`;
        }
      
        let txt_;
        if (/\dWK$/.test(bigger_tag) || /\dWKS$/.test(bigger_tag) || /\dWKVARIABLE$/.test(bigger_tag) || /\dWKSVARIABLE$/.test(bigger_tag)) {
          txt_ = `${bigger_date.replace('-', ' to ')} weeks to ship`;
        } else if (/\d$/.test(bigger_tag) || /\dVARIABLE$/.test(bigger_tag)) {
          txt_ = `<span>${bigger_date.replace('-', ' to ')} business days to ship.</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }
      
        return txt_;
      }

      function getETAShippingMessage(inventoryData) {
        let eta = inventoryData.eta_date;
        let eta_date = new Date(eta);
        let today = new Date();
        let diff = (eta_date - today)/1000;
        let week = 60 * 60 * 24 * 7;
        let min_week = Math.max(1, Math.floor(diff / week));
        let max_week = min_week + 2;
        if (eta_date < today) {
          return "Please contact support for shipping information.";
        }
        return `${min_week} to ${max_week} weeks to ship`;
      }

      function filteredLeadTimeText(tags, variant_sku, variant_inventory) {
        let result_txt = filteredSkuDateShip(tags, variant_sku);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredShippingTag(tags, variant_sku);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredBoShipping(tags, variant_sku, variant_inventory);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredOnlyBoTags(tags);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredMultiBoTags(tags);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredQuickshipShipping(tags, variant_inventory);
        if (result_txt) {
          return result_txt;
        }
      
        result_txt = filteredQuickshipping(tags, variant_inventory);
        if (result_txt) {
          return result_txt;
        }
      
        return null;
      }

      function filteredSkuDateShip(tags, variant_sku) {
        let tags_with_sku = tags.filter(tag => tag.includes(variant_sku));
        if (!tags_with_sku.length) {
          return null;
        }
      
        let ship_tag = tags_with_sku.find(tag => tag.includes("_SHIP"));
      
        if (ship_tag && ship_tag.includes(variant_sku)) {
          if (ship_tag.includes("_AVAIL_") || ship_tag.includes("_INVALID DATE_") || ship_tag.includes("_NOATCBUTTON_") || ship_tag.includes("_NOETANOTIFY_")) {
            return null;
          } else {
            let ship_time = ship_tag.split("_")[1];
            let time = new Date(ship_time.replace("-", " "));
            let now = new Date();
            let dif = (time - now) / 1000;
            let week = 60 * 60 * 24 * 7;
            let min_week = Math.max(1, Math.floor(dif / week));
            let max_week = min_week + 2;
            if (time < now) {
              return "Please contact support for shipping information.";
            } else {
              return `${min_week} to ${max_week} weeks to ship`;
            }
          }
        }
      
        return null;
      }

      function filteredShippingTag(tags, variant_sku) {
        let shipping_tags = tags.filter(tag => /^SHIPPING\d/.test(tag));
        if (!shipping_tags.length) {
          return null;
        }
      
        let bigger_tag, bigger_date;
        if (shipping_tags.length) {
          let stripped_numbers = shipping_tags.map(tag => tag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, ''));
          let additions = stripped_numbers.map(tag => tag.split('-').reduce((a, b) => parseInt(a) + parseInt(b), 0));
          let bigger_number = Math.max(...additions);
          let index_of_bigger_number = additions.indexOf(bigger_number);
          bigger_tag = shipping_tags[index_of_bigger_number];
          bigger_date = stripped_numbers[index_of_bigger_number];
        } else {
          bigger_tag = shipping_tags[0];
          bigger_date = bigger_tag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, '');
        }
      
        if (bigger_tag.endsWith("WH")) {
          return `<span>${bigger_date.replace('-', ' to ')} business days to leave the warehouse</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }
      
        if (["SHIPPING2-3VARIABLE", "SHIPPING3-4VARIABLE", "SHIPPING3-5VARIABLE"].includes(bigger_tag)) {
          return `<span>${bigger_date.replace('-', ' to ')} weeks to ship.</span>`;
        }
      
        let txt_;
        if (/\dWK$/.test(bigger_tag) || /\dWKS$/.test(bigger_tag) || /\dWKVARIABLE$/.test(bigger_tag) || /\dWKSVARIABLE$/.test(bigger_tag)) {
          txt_ = `${bigger_date.replace('-', ' to ')} weeks to ship`;
        } else if (/\d$/.test(bigger_tag) || /\dVARIABLE$/.test(bigger_tag)) {
          txt_ = `<span>${bigger_date.replace('-', ' to ')} business days to ship.</span> Lead times may be extended based on availability, customer service will contact you with any updates.`;
        }
      
        return txt_;
      }

      function filteredBoShipping(tags, variant_sku, variant_inventory) {
        let BO_tag = tags.find(tag => tag.includes('BO-Shipping'));
        let avail_ship_tag_ = tags.find(tag => tag.includes(`${variant_sku}_AVAIL_SHIP`));
      
        if (BO_tag && !avail_ship_tag_) {
          if (quickshipEnable(tags, variant_inventory)) {
            return "Ships in 1-2 business days";
          }
      
          let BO_shipping_date = BO_tag.replace("BO-Shipping ", "");
          let last_year = BO_shipping_date.split(" ").pop();
          let bo_tag_substring = BO_tag.slice(BO_tag.indexOf(" ") + 1);
          let bo_tag_substring_date = bo_tag_substring.split(" ")[0];
          let bo_tag_substring_month = bo_tag_substring.split(" ")[1];
      
          let month_names = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
      
          let bo_tag_substring_index = month_names.findIndex(month => month === bo_tag_substring_month) + 1;
      
          let date_list = [];
          let start, end;
          if (bo_tag_substring_date.toLowerCase() === "early") {
            start = 1; end = 11;
          } else if (bo_tag_substring_date.toLowerCase() === "mid") {
            start = 11; end = 21;
          } else if (bo_tag_substring_date.toLowerCase() === "late") {
            start = 21; end = 30;
          }
      
          for (let i = start; i < end; i++) {
            let date_loop = `${new Date().getFullYear()}/${bo_tag_substring_index}/${i}`;
            date_list.push(date_loop);
          }
      
          for (let date of date_list) {
            let new_date = new Date(date);
            let compare_date = `${last_year}/${bo_tag_substring_index}/${new_date.getDate()}`;
            let date_compare_obj = new Date(compare_date);
            let latest_date = new Date();
      
            if (date_compare_obj > latest_date) {
              return `Estimated Shipping Date: ${BO_shipping_date}.`;
            } else {
              return "4 to 8 weeks to ship";
            }
          }
        }
      
        return null;
      }

      function filteredOnlyBoTags(tags) {
        let only_bo_tags = tags.find(tag => /^BO\s-\Shipping\s/.test(tag));
        if (only_bo_tags) {
          // Uncomment the following line if you have a function named quickshipEnable
          // if (quickshipEnable() == true) return;
          let weeks = only_bo_tags.replace(/^BO\s-\Shipping\s/, "");
          let txt_ = `Purchase now and we'll ship when it's available.<br>Estimated Shipping Date: ${weeks}.`;
          return txt_;
        }
        
        return null;
      }

      function filteredMultiBoTags(tags) {
        let multi_bo_tags = tags.find(tag => /^MULTI-BO-SHIPPING-\d/.test(tag));
        if (multi_bo_tags) {
          // Uncomment the following line if you have a function named quickshipEnable
          // if (quickshipEnable() == true) return;
          let weeks = multi_bo_tags.replace(/^MULTI-BO-SHIPPING-/, "");
          let txt_;
          if (weeks.includes("WK")) {
            txt_ = weeks.replace("-", " to ").replace("WK", " weeks");
          } else {
            txt_ = `${weeks.replace('-', ' to ')} business days to ship`;
          }
          return txt_;
        }
        
        return null;
      }

      function filteredQuickshipShipping(tags, variant_inventory) {
        let quickship_tag = tags.find(tag => /^QUICKSHIP-SHIPPING-\d/.test(tag));
        if (quickship_tag) {
          let weeks = quickship_tag.replace(/^QUICKSHIP-SHIPPING-/, "");
          let time_type = "business days";
          if (/\dWK$/.test(weeks)) {
            weeks = weeks.replace(/WK$/, "");
            time_type = "weeks";
          }
      
          if (variant_inventory > 0) {
            // Uncomment the following lines if you want to display a message
            // quickship_badge.show();
            // console.log("If showing Quick Ship, item ships within 1 to 2 business days (limited quantities may apply).");
          } else {
            let txt_ = `${weeks.replace('-', ' to ')} ${time_type} to ship`;
            return txt_;
          }
        }
        
        return null;
      }

      function filteredQuickshipping(tags, variant_inventory) {
        let quickship_tag = tags.find(tag => /^QUICKSHIP\d-\d/.test(tag));
        if (quickship_tag) {
          let weeks = quickship_tag.replace(/^QUICKSHIP/, "");
          let time_type = "business days";
          if (/\dWK$/.test(weeks)) {
            weeks = weeks.replace(/WK$/, "");
            time_type = "weeks";
          }
      
          if (variant_inventory > 0) {
            // Uncomment the following lines if you want to display a message
            // quickship_badge.show();
            // console.log("If showing Quick Ship, item ships within 1 to 2 business days (limited quantities may apply).");
          } else {
            let txt_ = `${weeks.replace('-', ' to ')} ${time_type} to ship`;
            return txt_;
          }
        }
        
        return null;
      }

      function handleSkuDateShip(tags, variant_sku) {
        let tags_with_sku = tags.filter(tag => tag.includes(variant_sku));
      
        const SHIP_TAG_IDENTIFIER = "_SHIP";
        let ship_tag = tags_with_sku.find(tag => tag.includes(SHIP_TAG_IDENTIFIER));
      
        if (ship_tag) {
          let ship_tag_substring = ship_tag.replace(variant_sku, "");
          const INVALID_DATE_IDENTIFIER = "_INVALID DATE_";
          const AVAIL_IDENTIFIER = "_AVAIL_";
          const NOATCBUTTON_IDENTIFIER = "_NOATCBUTTON_";
          const NOETANOTIFY_IDENTIFIER = "_NOETANOTIFY_";
      
          if (AVAIL_IDENTIFIER in ship_tag_substring || INVALID_DATE_IDENTIFIER in ship_tag_substring || NOATCBUTTON_IDENTIFIER in ship_tag_substring || NOETANOTIFY_IDENTIFIER in ship_tag_substring) {
            // UNLESS THIS TAG HAS _AVAIL_ KEYWORD
          } else {
            let ship_time = ship_tag_substring.split("_")[1];
            let time = new Date(ship_time.replace("-", " "));
            let now = new Date();
            let dif = (time - now) / 1000;
            const SECONDS_IN_WEEK = 60 * 60 * 24 * 7;
            let min_week = Math.floor(dif / SECONDS_IN_WEEK);
            let max_week = min_week + 2;
      
            if (time < now) {
              const DEFAULT_SHIP_TIME = "4 to 8 weeks";
              return `Current estimated ship time is ${DEFAULT_SHIP_TIME}`;
            } else {
              let ship_time_message = `Ships in ${min_week <= 0 ? 1 : min_week} to ${max_week} weeks.`;
              return ship_time_message;
            }
          }
        }
      
        return null;
      }

      function handleNegativeInventory(tags, variant_sku, variant_inventory, vendor) {
        let has_zero_stock_eta = variant_inventory <= 0 && vendor === 'Currey & Company' && !tags.some(tag => tag.includes(`${variant_sku}_AVAIL_SHIP`));
      
        if (has_zero_stock_eta) {
          return 'Currently in production, estimated availability is currently over 90 days.';
        }
      
        return null;
      }

      function handleConfirmedMwDisco(tags, variant_sku, variant_id, variant_inventory) {
        if (tags.includes(`${variant_sku}_CONFIRMED-MWDISCO`)) {
          // let external_details = await getExternalSellDetails({"variant_id": variant_id}, 'SKU_CONFIRMED_MWDISCO');
          let external_details = null;
          let lead_time_txt = filteredLeadTimeText(tags, variant_sku, variant_inventory);
      
          if (external_details) {
            if (external_details.data.available_quantity) {
              if (external_details.data.external_quantity <= 0 && external_details.data.only_internal_quantity) {
                showQuickshipBadge();
                return 'Shipping time: 1 to 2 business days to ship. Lead times may be extended based on availability, customer service will contact you with any updates.';
              }
            }
      
            let intQty = external_details.data.external_quantity - external_details.data.tmp_external_quantity;
      
            if (intQty <= 0) {
              return 'Pre-order now, estimated shipping time 2 to 4 weeks';
            } else {
              return lead_time_txt;
            }
          } else {
            showNoEtaButtons();
            hidePaymentButtons();
            hideShippingMessageContainer();
            return 'activate no ATC button';
          }
        }
      
        return null;
      }

      function handleSkuConfirmedMwDiscoOos(tags, variant_sku) {
        if (tags.includes(`${variant_sku}_CONFIRMED-MWDISCO-OOS`)) {
          showBackInStockButton();
          hidePaymentButtons();
          hideShippingMessageContainer();
          return "activate Notify Me";
        }
      
        return null;
      }

      function handleAssumedMwDisco(tags, variant_sku) {
        if (tags.includes(`${variant_sku}_ASSUMED-MWDISCO`) || tags.includes(`${variant_sku}_NOETANOTIFY_SHIP`)) {
          showBackInStockButton();
          hidePaymentButtons();
          hideShippingMessageContainer();
          return "activate Notify Me";
        }
      
        return null;
      }

      function handleNoname(tags, variant_sku, variant_inventory, vendor) {
        let noetawithsku = `${variant_sku}_NOETA_SHIP`;
        let discontinuedwithsku = `${variant_sku}_discontinued_mw`;
        let noATCTagWithSKU = `${variant_sku}_NOATCBUTTON_SHIP`;
        let has_zero_stock_eta = variant_inventory <= 0 && vendor == 'Currey & Company' && !tags.some(tag => tag.includes(`${variant_sku}_AVAIL_SHIP`));
      
        let no_eta_tag = tags.find(tag => tag.includes(noetawithsku));
        let no_atc_button = tags.find(tag => tag == "NOATCBUTTON");
        let no_atc_button_with_sku = tags.find(tag => tag == noATCTagWithSKU);
        let discontinued_tag = tags.find(tag => tag.includes(discontinuedwithsku));
      
        let no_eta = tags.find(tag => tag.startsWith("NOETA"));
        let noeta = tags.find(tag => tag.startsWith("noeta"));
      
        if (no_eta_tag || discontinued_tag) {
          if (!has_zero_stock_eta) {
            return 'For Shipping Information Please Contact Support.';
          }
        }
      
        if (no_atc_button || no_atc_button_with_sku ) {
          showNoEtaButtons();
          hidePaymentButtons();
          return 'This product is currently unavailable. Please contact client services for additional information.';
        }
      
        if (no_eta == "NOETA" || noeta == "noeta") {
          if (!has_zero_stock_eta) {
            return 'For Shipping Information Please Contact Support.';
          }
        }
      
        if (has_zero_stock_eta) {
          return 'Currently in production, estimated availability is currently over 90 days.';
        }
      
        return null;
      }

      function handleReadyToShip(tags, variant_sku, variant_inventory) {
        let ready_to_ship = tags.find(tag => tag.includes(`${variant_sku}_READYTOSHIP`));
        let result = "";
      
        if (ready_to_ship && variant_inventory <= 0) {
          showReadyToShipBadge();
          result = '<p>IN-STOCK + READY TO SHIP</p>';
          // readyToShipMessageText.innerHTML = "<br>Ready to ship shipping times are estimated and may be subject to change based on warehouse and carrier speeds and scheduling. Please allow transit time for your item to arrive. Client services will communicate the most up to date information for delivery and shipments and extended lead times. <br>";
        }
      
        let lead_time_txt = filteredLeadTimeText(tags, variant_sku, variant_inventory);
         
      
        if (lead_time_txt) {
          if (result != "") {
            result += `<p>Shipping time: ${lead_time_txt}</p>`;
          } else {
            result = '<p>Shipping time: ' + lead_time_txt + '</p>';
          }
        }
      
        if (result != "") {
          return result;
        }
      
        return null;
      }

      function handleShipping(tags, variant_sku, variant_inventory) {
        let lead_time_txt = filteredLeadTimeText(tags, variant_sku, variant_inventory);
      
        if (lead_time_txt) {
          return lead_time_txt;
        }
      
        return null;
      }
    },
    updateSample(event) {
      const selectors = {
        sampleAddToCart: '.sample-add-to-cart',
      }

      const sampleButton = this.$root.querySelector(selectors.sampleAddToCart);
      if (!sampleButton) return;

      const variantMeta = this.variantsMetaDataObject[this.currentVariantId];
      const sampleId = variantMeta?.sample_id;

      if (sampleId) {
        sampleButton.setAttribute('data-sample-id', sampleId);
        sampleButton.classList.remove('hide');
      } else {
        sampleButton.classList.add('hide');
      }
    },
    sampleAddToCart(event) { 
      const { productHandle } = event.detail;
      const sampleButton = this.$refs.sampleAddToCartButton;
      if (!sampleButton) return;

      const sampleId = sampleButton.getAttribute('data-sample-id');
      const sampleHandle = sampleButton.getAttribute('data-sample-handle');
      if (!sampleId) return;

      if (sampleHandle) {
        // Redirect to the sample product page
        window.location.assign(`/products/${sampleHandle}`);
        return;
      }


      this.loading = true;
      this.addedToCart = false;

      const formData = new FormData();
      formData.append('id', sampleId);
      formData.append('quantity', 1);
      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfigDefaults('javascript');
      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          this.loading = false;
          this.cartAddErrorMessage = null;
          this.addedToCart = true;
          document.body.dispatchEvent(
            new CustomEvent('cascade:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        });
    },
    contactCustomerService(event) {
      const customerServiceButton = this.$refs.contactCustomerServiceButton;
      if (!customerServiceButton) return;

      const customerServiceModal = this.$refs.customerServiceModal;
      if (customerServiceModal) {
        customerServiceModal.classList.remove('hide');
      } else {
        console.error("Customer Service modal not found");
      }

    },
    __updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;

      this.storeAvailability =
        this.storeAvailability ||
        new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    optionChange() {
      this.getOptionHandles();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );

      this.currentVariant = matchedVariant;

      if (this.currentVariant) {
        variantLiveRegion(this.currentVariant);
        this.updateStoreAvailability(this.currentVariant);

        if (this.currentVariant.featured_media) {
          this.currentMediaId = this.currentVariant.featured_media.id;
        }

        const url = ShopifyProductForm.getUrlWithVariant(
          window.location.href,
          this.currentVariant.id
        );

        this.$root.dispatchEvent(
          new CustomEvent('product-url-update', {
            bubbles: true,
            detail: { url: url },
          })
        );

        const inFormNameEl =
          this.$refs.singleVariantSelector || this.$refs.productFormNameField;

        if (inFormNameEl) {
          inFormNameEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.$root.dispatchEvent(
          new CustomEvent('cascade:product:variantchange', {
            bubbles: true,
            detail: { variant: this.currentVariant },
          })
        );

        this.variantChanged = true;
      }
    },
    getOptionHandles() {
      this.optionHandles = [];

      const selectors = this.productForm.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    async submitForm(evt) {
      evt.preventDefault();
      this.loading = true;
      this.addedToCart = false;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(evt.target);
      const formId = evt.target.getAttribute('id');

      let modalCart = theme.settings.cart_type === 'drawer';

      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // fetch(`${theme.routes.cart_add_url}`, config)
      //   .then((res) => res.json())
      //   .then((data) => {
      //     if (data.status) {
      //       this.loading = false;

      //       const errors = data.errors || data.description;
      //       const message = data.description || data.message;

      //       // Gift card recipient form errors are handled in gift-card-recipient.js
      //       if (!this.hasGiftCardRecipientForm) {
      //         this.cartAddErrorMessage =
      //           message || window.theme.strings.cartError;
      //       }

      //       document.body.dispatchEvent(
      //         new CustomEvent('cascade:cart:adderror', {
      //           detail: {
      //             source: 'product-form',
      //             sourceId: formId,
      //             variantId: formData.get('id'),
      //             errors,
      //             message,
      //           },
      //         })
      //       );
      //       return;
      //     }

      //     this.loading = false;
      //     this.cartAddErrorMessage = null;
      //     this.addedToCart = true;

      //     if (modalCart) {
      //       document.body.dispatchEvent(
      //         new CustomEvent('cascade:modalcart:afteradditem', {
      //           bubbles: true,
      //           detail: { response: data },
      //         })
      //       );
      //     }

      //     if (!document.querySelector('[data-show-on-add="true"]')) {
      //       if (this.$refs.added)
      //         this.$nextTick(() => this.$refs.added.focus());
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });

      try {

        if (this.maxValue) {
          const formQuantity = parseInt(formData.get('quantity'));
          const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
          const cartData = await cartResponse.json();
          const cartItem = cartData.items.find(item => item.id === this.currentVariant.id);

          if (cartItem) { 
            const cartQuantity = parseInt(cartItem.quantity);
            if (cartQuantity + formQuantity > this.maxValue) {
              this.loading = false;
              this.cartAddErrorMessage = `You can only add ${this.maxValue} items to the cart.`;
              return;
            }
          }
        }

        const response = await fetch(`${theme.routes.cart_add_url}`, config);
        const data = await response.json();
        
        if (data.status) {
          this.loading = false;
    
          const errors = data.errors || data.description;
          const message = data.description || data.message;
    
          // Gift card recipient form errors are handled in gift-card-recipient.js
          if (!this.hasGiftCardRecipientForm) {
            this.cartAddErrorMessage = message || window.theme.strings.cartError;
          }
    
          document.body.dispatchEvent(
            new CustomEvent('cascade:cart:adderror', {
              detail: {
                source: 'product-form',
                sourceId: formId,
                variantId: formData.get('id'),
                errors,
                message,
              },
            })
          );
          return;
        }
    
        this.loading = false;
        this.cartAddErrorMessage = null;
        this.addedToCart = true;
    
        if (modalCart) {
          document.body.dispatchEvent(
            new CustomEvent('cascade:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        }
    
        if (!document.querySelector('[data-show-on-add="true"]')) {
          if (this.$refs.added)
            this.$nextTick(() => this.$refs.added.focus());
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    openZoom(mediaId) {
      const zoomModalId = `image-zoom-${this.productRoot.id}`;

      if (!this.$store.modals.modals[zoomModalId]) {
        this.$store.modals.register(zoomModalId, 'modal');
      }

      this.$watch('$store.modals.modal.contents', (val) => {
        if (val === zoomModalId) {
          this.$nextTick(() => {
            const zoomModalEl = document.getElementById(zoomModalId);

            waitForContent(zoomModalEl).then(() => {
              const mediaEl = zoomModalEl.querySelector(
                `[data-media-id="${mediaId}"]`
              );

              if (mediaEl) {
                mediaEl.scrollIntoView();
              }
            });
          });
        }
      });

      this.$store.modals.open(zoomModalId);
    },
  };
};
